export const landing = [
	{
		title: 'Switch',
		tagline: 'A world of numerous job opportunities awaits you',
		icon: 'https://i.ibb.co/RDGnT1T/stract.png',
	},
	{
		title: 'The Library',
		tagline:
			'Commit to self-growth by key insights from best selling books',
		icon: 'https://i.ibb.co/NFSFtJb/books-v1.png',
	},
	
	{
		title: 'FinAcademy',
		tagline: 'Videos, books and other resources to help you build a solid foundation of success',
		icon: 'https://i.ibb.co/ssRM04p/course.png',
	},
	{
		title: 'Quick Bites',
		tagline:
			'Blogs on cryptocurrency, stocks and much more.',
		icon: 'https://i.ibb.co/GMJJsLy/blog-v2.png',
	},
	{
		title: 'Uplift',
		tagline:
			'Thousands of Motivational quotes',
		icon: 'https://i.ibb.co/yYWt7tQ/motivation-v2.png',
	},
];
